import { FormattedText, useConfirmationDialog } from "client/Components";
import { localize } from "client_legacy/ndaw/culture";
import { ReactElement, useCallback } from "react";
import styles from "./CommunityDeletionConfirmationDialog.module.less";

export function useCommunityDeletionConfirmationDialog(): [
	element: ReactElement | null,
	open: () => Promise<TryResult<void>>
] {
	const [element, openConfirmationDialog] = useConfirmationDialog();

	const open = useCallback(
		(): Promise<TryResult<void>> => {
			return openConfirmationDialog({
				trackingId: "delete-community-confirmation-dialog",
				title: localize("_AreYouSureYouWantToDeleteThisCommunity"),
				confirmText: localize("_Delete"),
				children: (
					<span className={styles.dangerText}>
						<FormattedText
							text={localize("_NoteAllPostWithinThisCommunityWillBeDeletedAsWell")}
							thingsToWrap={[
								{
									blockId: "Note",
									wrap: (x) => <b>{x}</b>
								}
							]}
						/>
					</span>
				)
			});
		},
		[openConfirmationDialog]
	);

	return [element, open];
}
